// Kurye Ekipman Yönetimi ekranı (GET /courier-equipment/list) sadece bu üç onboarding
// durumundaki kuryeleri listeler. Kurye listesindeki ekipman aksiyonlarının da aynı
// kuryelerde çalışması için buradaki kombinasyonlar birebir o sorgudaki $match ile eşleşir.
const EQUIPMENT_ELIGIBLE_ONBOARDING_STATES = [
    {
        // Ekipman tamamlanması beklenen kuryeler
        activationStep: "candidate",
        activationSubStep: "equipmentCompletion",
        activationPhase: "equipment"
    },
    {
        // Vardiya beklenen kuryeler
        activationStep: "approved",
        activationSubStep: "shiftWaiting",
        activationPhase: "shiftWaiting"
    },
    {
        // Onaylı kuryeler
        activationStep: "approved",
        activationSubStep: "approved",
        activationPhase: "none"
    }
];

export const INELIGIBLE_COURIER_TOOLTIP =
    "Bu kurye ekipman aşamasında değil, ekipman işlemi yapılamaz";

export const isEquipmentEligibleCourier = courier =>
    EQUIPMENT_ELIGIBLE_ONBOARDING_STATES.some(
        state =>
            state.activationStep === courier?.activationStep &&
            state.activationSubStep === courier?.activationSubStep &&
            state.activationPhase === courier?.activationPhase
    );

// Ekipman yönetimi ekranı iade butonunu handoveredEquipments.length > 0 ile açıyor.
// Bu alan kurye listesi cevabında gelmiyor; assignmentStatus "assigned" olduğunda
// completeEquipmentAssignment ekipmanları "handovered"a çektiği için aynı anlama gelir.
export const hasHandoveredEquipment = courier =>
    courier?.equipmentInfo?.assignmentStatus === "assigned";
